import L, { LatLngExpression } from 'leaflet';
import { MarkerClusterGroup } from 'leaflet.markercluster/src';

const iconPath = new URL('../../assets/img/marker-icon.svg', import.meta.url).toString();

type TMarker = {
    coordinates: LatLngExpression;
    text: string;
};

type TMarkers = { [key: string]: TMarker };

const mapJsClass = 'js-map';

const mapElements = document.querySelectorAll('.' + mapJsClass) as NodeListOf<HTMLElement>;

const defaultCoordinates: LatLngExpression = [48.856659350090915, 2.3524410334222425];
const defaultZoom = 15;

mapElements.forEach((mapElement) => {
    // Get zoom from data attribute
    const zoom = mapElement.dataset.zoom ? JSON.parse(mapElement.dataset.zoom) : defaultZoom;

    // Create map
    const map = L.map(mapElement, {
        zoom: 13,
        zoomControl: false
    });

    // Give map a tileLayer
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: 20
    }).addTo(map);

    // Get markers from data attribute
    const markers: TMarkers = mapElement.dataset.markers && JSON.parse(mapElement.dataset.markers);

    // Create custom marker icon
    const markerIcon = L.icon({
        iconUrl: iconPath,
        iconSize: [25, 32],
        iconAnchor: [12.5, 32]
    });

    const markersCoordinates = [];

    // Create cluster group
    const markerClusterGroup = new MarkerClusterGroup({
        showCoverageOnHover: false
    });

    if (markers) {
        // For each marker
        Object.keys(markers).forEach((key) => {
            // Add coordinates to array
            markersCoordinates.push(markers[key].coordinates);

            // Create marker
            const marker = L.marker(markers[key].coordinates, { icon: markerIcon });

            if (markers[key].text) {
                // Bind popup to marker
                marker.bindPopup(getPopupContent(markers[key])).openPopup();
            }

            // Add marker to cluster group
            markerClusterGroup.addLayer(marker);
        });

        // Add cluster group to map
        map.addLayer(markerClusterGroup);
    }

    // Get zoom control labels from the data attribute
    const zoomInTitle = mapElement.dataset.zoomInTitle;
    const zoomOutTitle = mapElement.dataset.zoomOutTitle;

    // Create zoom control labels
    if (zoomInTitle && zoomOutTitle) {
        L.control.zoom({
            zoomInTitle: zoomInTitle,
            zoomOutTitle: zoomOutTitle
        }).addTo(map);
    }

    // Center map
    if (markersCoordinates.length > 1) {
        // Multiple markers
        const mapBounds = new L.LatLngBounds(markersCoordinates);
        map.fitBounds(mapBounds);
    } else if (markersCoordinates.length === 1) {
        // One marker
        map.setView(markersCoordinates[0], zoom);
    } else {
        // No markers
        map.setView(defaultCoordinates, zoom);
    }
});

function getPopupContent (marker: TMarker): string {
    const { text } = marker;

    const componentClass = 'c-map-popup';

    return `
        <div class="${componentClass}">
            <div class="${componentClass}__text">${text}</div>
        </div>
    `;
}